// /src/engine/partsCatalog.ts

export type PartCategory = 'Bricks' | 'Plates' | 'Tiles' | 'Technic' | 'Basics';

export type PartDef = {
  name: string;
  file: string; // LDraw part file, e.g. "3001.dat"
  category: PartCategory;
  studs: { w: number; d: number; plates: number };
  defaultColor: number; // LDraw color id
  defaultHex: string;
};

export const PARTS: PartDef[] = [
  {
    name: 'Brick 2 x 4',
    file: '3001.dat',
    category: 'Bricks',
    studs: { w: 2, d: 4, plates: 3 },
    defaultColor: 4,
    defaultHex: '#c91a09'
  },
  {
    name: 'Brick 2 x 2',
    file: '3003.dat',
    category: 'Bricks',
    studs: { w: 2, d: 2, plates: 3 },
    defaultColor: 1,
    defaultHex: '#ffffff'
  },
  {
    name: 'Brick 1 x 2',
    file: '3004.dat',
    category: 'Bricks',
    studs: { w: 1, d: 2, plates: 3 },
    defaultColor: 14,
    defaultHex: '#f2cd37'
  },
  {
    name: 'Plate 2 x 4',
    file: '3020.dat',
    category: 'Plates',
    studs: { w: 2, d: 4, plates: 1 },
    defaultColor: 2,
    defaultHex: '#0055bf'
  },
  {
    name: 'Plate 1 x 2',
    file: '3023.dat',
    category: 'Plates',
    studs: { w: 1, d: 2, plates: 1 },
    defaultColor: 10,
    defaultHex: '#6d6e5c'
  },
  {
    name: 'Tile 2 x 2',
    file: '3068b.dat',
    category: 'Tiles',
    studs: { w: 2, d: 2, plates: 1 },
    defaultColor: 0,
    defaultHex: '#101010'
  },
  {
    name: 'Technic Brick 1 x 4 (holes)',
    file: '3701.dat',
    category: 'Technic',
    studs: { w: 1, d: 4, plates: 3 },
    defaultColor: 71,
    defaultHex: '#a0a5a9'
  },
  {
    name: 'Axle 4',
    file: '3705.dat',
    category: 'Technic',
    studs: { w: 1, d: 1, plates: 1 },
    defaultColor: 72,
    defaultHex: '#646464'
  }
];

export const PART_CATEGORIES: PartCategory[] = ['Basics', 'Bricks', 'Plates', 'Tiles', 'Technic'];

function normalizePartRef(file: string): string {
  const cleaned = String(file ?? '')
    .replace(/\\/g, '/')
    .trim()
    .toLowerCase();
  if (!cleaned) return '';
  const base = cleaned.split('/').pop();
  return (base ?? cleaned).trim();
}

export function findPartDef(file: string): PartDef | undefined {
  const key = normalizePartRef(file);
  if (!key) return undefined;
  return PARTS.find((p) => normalizePartRef(p.file) === key);
}
